import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { SkechersCoLineRequest } from "@project-management-system/shared-models";
import { Repository } from "typeorm";
import { SkechersCOLineEntity } from "../entity/skechers-co-line.entity";


@Injectable()
export class SkechersCOLineRepository extends Repository<SkechersCOLineEntity> {

    constructor(@InjectRepository(SkechersCOLineEntity) private skechersCoLineRepository: Repository<SkechersCOLineEntity>
    ) {
        super(skechersCoLineRepository.target, skechersCoLineRepository.manager, skechersCoLineRepository.queryRunner);
    }

    async getCentricCoLineData(req?: SkechersCoLineRequest): Promise<any[]> {
        const query = this.createQueryBuilder('co')
            .select(`DISTINCT co.po_number, co.po_style,co.ex_factory_date,co.delivery_date, co.item_no, co.color, co.co_number, co.co_date, co.status, co.error_msg,
                   DATE_FORMAT(co.created_at, '%m/%d/%Y %H:%i') as raised_date, co.created_user,co.id,co.updated_at,co.price`)
            .andWhere(`NOT(co.status = 'Success' AND co.isActive = 0)`)
            .orderBy('co.created_at', 'DESC');


        if (req?.poNumber !== undefined) {
            query.andWhere(`co.po_number = :poNumber`, { poNumber: req.poNumber });
        }
        if (req?.itemNo !== undefined) {
            query.andWhere(`co.item_no = :itemNo`, { itemNo: req.itemNo });
        }
        if (req?.poStyle !== undefined) {
            query.andWhere(`co.po_style = :poStyle`, { poStyle: req.poStyle });
        }
        if (req?.price !== undefined) {
            query.andWhere(`co.price = :price`, { price: req.price });
        }

        return await query.getRawMany();
    }

    async getCoPoNumber(): Promise<any[]> {
        const query = this.createQueryBuilder('co')
            .select(`co.id,co.po_number`)
            .groupBy(`co.po_number`)
        return await query.getRawMany();
    }
    async getItem(): Promise<any[]> {
        const query = this.createQueryBuilder('co')
            .select(`co.id,co.item_no`)
            .groupBy(`co.item_no`)
        return await query.getRawMany();
    }
    async getOrderNumber(): Promise<any[]> {
        const query = this.createQueryBuilder('co')
            .select(`co.id,co.po_style`)
            .groupBy(`co.po_style`)
        return await query.getRawMany();
    }

    async getDataforCOLineCreation(): Promise<any> {
        const query = this.createQueryBuilder('co')
            .select(`co.id, co.po_number,co.po_style, co.item_no,co.price`)
            .where(` status !='Success' AND status != 'Inprogress' AND is_active = true`)
            .orderBy(` created_at`, 'ASC')
        return await query.getRawOne();
    }

}